;(function ($) {

    $.fn.loadMore = function () {

        var $body = this,
            $container = $body.find('#animated-thumbnails'),
            offset = 12,
            busy = false,
            button = $body.find('.gallery-load-more');

        var loadMore = function () {
            if (!busy) {
                busy = true;

                button.text('Loading...');

                $.ajax({
                    url: '/',
                    data: {
                        gallery_load_more: true,
                        offset: offset
                    },
                    dataType: 'json',
                    success: onSuccess
                });
            }
        };

        var onSuccess = function (response) {
            var html = '';

            if (response.length > 0) {
                $.each(response, function (i, photo) {
                    html += '<a href="' + photo.url + '" data-sub-html="Photo by ' + photo.title + '<br />' + photo.excerpt + '"><img src="' + photo.url + '" /></a>';
                });

                $container.append($(html)).masonry('reloadItems').masonry('layout');
                $container.imagesLoaded(function() {
                    $container.masonry('layout');

                    setTimeout(function() {
                        $container.masonry('layout');
                    }, 1000);
                });

                window.lightgallery.data('lightGallery').destroy(true);
                window.setupLightgallery();

                offset += response.length;
                button.text('Load more');
                busy = false;
            } else {
                button.remove();
            }
        };

        $body.on('click', '.gallery-load-more', function (e) {
            e.preventDefault();

            loadMore();
        });

        return this;

    };

})(jQuery);